import React from 'react';

function Footer() {
    return ( <footer >
      

        <div className = "copyright" >

        
        Made a huge income from our products? Want to give us any appreciations? <a href="donate-us" className="footer-link">[DONATE TO US HERE]</a> 
        </div> 
        </footer >
    );
}

export default Footer;